// Affiliate tracking helper - SOLO localStorage, nessun Redux

// Cookie name for affiliate tracking (usiamo quello da config, ma hardcoded qui per semplicità)
const AFFILIATE_COOKIE_NAME = 'affiliate_cookie';
const COOKIE_DURATION_DAYS = 60;

// Parse URL parameters to extract affiliate data
export const parseAffiliateParams = (url) => {
  const urlParams = new URLSearchParams(url.split('?')[1] || '');
  const ref = urlParams.get('ref');
  const source = urlParams.get('source');
  const campaign = urlParams.get('campaign');

  if (ref) {
    return {
      affiliateCode: ref,
      source: source || 'direct',
      campaign: campaign || 'default',
      timestamp: new Date().toISOString(),
    };
  }
  return null;
};

// Set affiliate cookie from URL parameters (sovrascrive sempre con l'ultimo link visitato)
export const setAffiliateFromURL = (url) => {
  const affiliateData = parseAffiliateParams(url);
  if (affiliateData) {
    setAffiliateCookie(affiliateData); // Sovrascrive sempre
    return affiliateData;
  }
  return null;
};

// Set affiliate cookie in localStorage (aggiunge expiryDate)
export const setAffiliateCookie = (affiliateData) => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + COOKIE_DURATION_DAYS);
  const cookieData = {
    ...affiliateData,
    expiryDate: expiryDate.toISOString(),
  };
  localStorage.setItem(AFFILIATE_COOKIE_NAME, JSON.stringify(cookieData));
};

// Get affiliate cookie from localStorage
export const getAffiliateCookieFromStorage = () => {
  try {
    const cookieData = localStorage.getItem(AFFILIATE_COOKIE_NAME);
    return cookieData ? JSON.parse(cookieData) : null;
  } catch (error) {
    console.error('Error reading affiliate cookie:', error);
    return null;
  }
};

// Check if affiliate cookie is expired
export const isCookieExpired = (cookieData) => {
  if (!cookieData || !cookieData.expiryDate) return true;
  const expiryDate = new Date(cookieData.expiryDate);
  return expiryDate <= new Date();
};

// Clear affiliate cookie
export const clearAffiliateTracking = () => {
  localStorage.removeItem(AFFILIATE_COOKIE_NAME);
};

// Initialize affiliate tracking on page load
export const initializeAffiliateTracking = () => {
  // Expose the function to the window object so it can be called from index.html
  window.setAffiliateCookieWithConsent = () => {
    if (
      window._iub &&
      window._iub.cs &&
      typeof window._iub.cs.api.getPreferences === 'function'
    ) {
      const preferences = window._iub.cs.api.getPreferences();
      // Purpose 5 corresponds to "Marketing"
      if (preferences && preferences.purposes && preferences.purposes['5']) {
        const affiliateData = parseAffiliateParams(window.location.href);
        if (affiliateData) {
          setAffiliateCookie(affiliateData);
        }
      }
    }
  };
};

// Generate affiliate link
export const generateAffiliateLink = (
  affiliateCode,
  baseUrl,
  source = 'direct',
  campaign = 'default',
) => {
  const url = new URL(baseUrl);
  url.searchParams.set('ref', affiliateCode);
  url.searchParams.set('source', source);
  url.searchParams.set('campaign', campaign);
  return url.toString();
};

// Track affiliate conversion (chiamare quando avviene una conversione)
export const trackAffiliateConversion = (subscriptionData) => {
  const affiliateData = getAffiliateCookieFromStorage();
  if (affiliateData && !isCookieExpired(affiliateData)) {
    try {
      // Qui invieresti i dati al backend
      console.log('Affiliate conversion tracked:', {
        affiliateCode: affiliateData.affiliateCode,
        source: affiliateData.source,
        campaign: affiliateData.campaign,
        subscriptionData,
        conversionDate: new Date().toISOString(),
      });
      clearAffiliateTracking();
      return affiliateData;
    } catch (error) {
      console.error('Error tracking affiliate conversion:', error);
    }
  }
  return null;
};

// Utility: controlla se l'utente è affiliato
export const isAffiliateUser = () => {
  const affiliateData = getAffiliateCookieFromStorage();
  return affiliateData && !isCookieExpired(affiliateData);
};
